import { render, staticRenderFns } from "./BottomBar.vue?vue&type=template&id=dd1f0230&"
import script from "./BottomBar.vue?vue&type=script&lang=ts&"
export * from "./BottomBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports